<div class="redirect-modal">
    <div class="redirect-box">
      <p>Redirecionando…</p>
    </div>
  </div>